import React from "react";
import Spinner from "react-bootstrap/Spinner";

export default function LoadingFullComponent({ show }) {
  return (
    <div
      style={{
        width: "100%",
        height: "100%",
        backgroundColor: "rgba(255,255,255,0.2)",
        display: show ? "flex" : "none",
        justifyContent: "center",
        alignItems: "center",
        position: "absolute",
        top: 0,
        bottom: 0,
        left: 0,
        right: 0,
        zIndex: 999999,
        backdropFilter: "blur(10px)",
      }}
    >
      <Spinner
        animation="border"
        variant="primary"
        style={{
          width: 50,
          height: 50,
          borderWidth: 6,
        }}
      />
    </div>
  );
}
